import { Component } from '@angular/core';
import { LeaderboardType } from '@fgb/core';

@Component({
  selector: 'fgb-predictor-leaderboard',
  templateUrl: './predictor-leaderboard.component.html',
  styleUrl: './predictor-leaderboard.component.scss',
})
export class PredictorLeaderboardComponent {
  LeaderboardType: LeaderboardType = LeaderboardType.PredictorPoints;
}
